import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Merch accounting only — gross, print cost, net. Deliberately lives here
// (not on the main dashboard) so the top of /admin stays focused on
// donations, the 50/50 split and participants.
export const MerchAccounting = ({ token }) => {
  const [m, setM] = useState(null);

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const r = await fetch(`${BACKEND}/api/admin/fundraising/summary`, {
          headers: { "X-Admin-Token": token },
        });
        if (r.ok) setM((await r.json()).merch || {});
      } catch { /* non-critical */ }
    })();
  }, [token]);

  if (!m) return null;

  return (
    <div data-testid="merch-accounting" className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-4 max-w-3xl">
      {[
        ["Merch gross", money(m.gross), `${m.paid_orders || 0} paid order${m.paid_orders === 1 ? "" : "s"}`],
        ["Printful cost", money(m.printful_cost),
          m.orders_with_known_cost < m.paid_orders ? `${m.orders_with_known_cost}/${m.paid_orders} costs known` : "all costs known"],
        ["Net merch", money(m.net), "after print costs"],
        ["Goes to charity", money(m.net), "net merch is donated too"],
      ].map(([label, value, sub]) => (
        <div key={label} className="border border-white/10 bg-black/40 px-3 py-2">
          <div className="text-[9px] uppercase tracking-[0.22em] font-bold text-white/40">{label}</div>
          <div className="font-black text-lg text-white leading-none mt-1 tabular-nums">{value}</div>
          <div className="text-[10px] text-white/35 mt-1">{sub}</div>
        </div>
      ))}
    </div>
  );
};

export default MerchAccounting;
